import React from 'react'
import { Col, Row } from 'reactstrap'
import { Input } from './index'

interface AddressProps {
  namePrefix?: string
  namePrefixIncludeDot?: boolean
}

const Address: React.FC<AddressProps> = (props) => {
  const { namePrefix = '', namePrefixIncludeDot = true } = props
  const namePrefixDot = namePrefixIncludeDot && namePrefix !== '' ? `${namePrefix}.` : namePrefix
  return (
    <>
      <Input type='text' name={`${namePrefixDot}address.street`} label='Address' />
      <Row>
        <Col sm={12} md={6}>
          <Input type='text' name={`${namePrefixDot}address.city`} label='City' />
        </Col>
        <Col sm={12} md={3}>
          <Input type='text' name={`${namePrefixDot}address.state`} label='State' maxLength={2} />
        </Col>
        <Col sm={12} md={3}>
          <Input type='text' name={`${namePrefixDot}address.zip`} label='Zip' maxLength={5} />
        </Col>
      </Row>
    </>
  )
}

export default Address
export { Address }
